import { render } from "./BasicTextValue.vue?vue&type=template&id=55d0c224"
import script from "./BasicTextValue.vue?vue&type=script&lang=ts"
export * from "./BasicTextValue.vue?vue&type=script&lang=ts"
script.render = render

export default script